export default "__VITE_ASSET__DeRMppaJ__"